<template>
  <div class="form-field-wrap">
    <textarea
      class="form-textarea border--gray border--lighten-2"
      :ref="name"
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :readonly="readonly"
      @input="input($event)"
    ></textarea>
    <form-error
      :name="name"
      :error="error"
    ></form-error>
    <help-text :label="helpText"></help-text>
  </div>
</template>

<script>
import focusOnError from '@/component/ui/focusOnError'

export default {
  mixins: [focusOnError],
  props: {
    value: { type: [String, Number] },
    name: { type: String, required: true },
    error: { type: Object, required: true },
    type: { type: String, default: 'text' },
    readonly: { type: Boolean, default: false },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    helpText: { type: String, default: '' }
  },
  data () {
    return {
      focus: false
    }
  },
  methods: {
    input ($event) {
      // console.log('$evnet', $event)
      this.$emit('input', this.type === 'number' ? Number($event.target.value) : $event.target.value)
    },
    clear () {
      this.$emit('input', this.type === 'number' ? 0 : '')
    }
  },
  components: {
    FormError: () => import('@/component/ui2/form/FormError'),
    HelpText: () => import('@/component/ui2/common/HelpText')
  }
}
</script>
